import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCierreHoteleria = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'cierre_hoteleria',
        name: 'Cierre Hoteleria',
        component: ViewCierreHoteleria,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
